import {
  addDoc, collection, deleteDoc, doc, onSnapshot,
  orderBy, query, serverTimestamp, updateDoc, where,
} from 'firebase/firestore';
import { db } from '../../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../../config/Config';

const appId = FIREBASE_CONFIG.projectId;
const TASKS_PATH = ['artifacts', appId, 'public', 'data', 'client_tasks'];

function getTasksCollectionRef() {
  return collection(db, ...TASKS_PATH);
}

/**
 * 1. Assine tarefas de um cliente em tempo real.
 */
export function subscribeClientTasks(clientId, callback, onError) {
  const col = getTasksCollectionRef();
  const q = query(col, where('clientId', '==', clientId), orderBy('createdAt', 'desc'));
  return onSnapshot(q, callback, onError);
}

/**
 * 2. Cria uma nova tarefa.
 */
export async function createTask(data) {
  await addDoc(getTasksCollectionRef(), {
    ...data,
    createdAt: serverTimestamp(),
  });
}

/**
 * 3. Atualiza o status de uma tarefa para 'completed'.
 */
export async function completeTask(taskId) {
  const ref = doc(getTasksCollectionRef(), taskId);
  await updateDoc(ref, { status: 'completed' });
}

/**
 * 4. Atualiza o status de uma tarefa para 'pending'.
 */
export async function reopenTask(taskId) {
  const ref = doc(getTasksCollectionRef(), taskId);
  await updateDoc(ref, { status: 'pending' });
}

/**
 * 5. Atualiza o status de uma tarefa para 'rejected' com nota.
 */
export async function rejectTask(taskId, rejectionNote) {
  const ref = doc(getTasksCollectionRef(), taskId);
  await updateDoc(ref, { status: 'rejected', rejectionNote });
}

/**
 * 6. Deleta uma tarefa.
 */
export async function deleteTask(taskId) {
  await deleteDoc(doc(getTasksCollectionRef(), taskId));
}
